module.exports = __webpack_public_path__ + "img/dlgz.9b8b19b3.png";